import { BaseEntityModel } from '@/modules/core/app/models/abstracts/BaseEntityModel';
import { MessageClaraDraftSourceLocator } from '@/modules/messenger/_modules/message/models/MessageClaraDraftSourceLocator';
import { MessageClaraDraftSourceItem } from '@/modules/messenger/_modules/message/models/MessageClaraDraftSourceItem';
import { MessageClaraDraftSourceType } from '@/modules/messenger/_modules/message/constants/MessageClaraDraftSourceType';
import { MessageClaraDraftSourceSection } from '@/modules/messenger/_modules/message/constants/MessageClaraDraftSourceSection';
import { MessageClaraDraftSourceTab } from '@/modules/messenger/_modules/message/constants/MessageClaraDraftSourceTab';
import { MessageClaraDraftSourceSeparator } from '@/modules/messenger/_modules/message/constants/MessageClaraDraftSourceSeparator';
import { EstateDetailsMainTabValue } from '@/modules/ops/constants/EstateDetailsMainTabValue';

export class MessageClaraDraftSource extends BaseEntityModel {
  sourceId?: string;
  kind?: string;
  title?: string;
  excerpt?: string;
  type?: string | null;
  locator: MessageClaraDraftSourceLocator | null;
  snippet?: string | null;
  retrievedAt?: string | null;
  partner: boolean;
  items: MessageClaraDraftSourceItem[];

  constructor(model: Partial<MessageClaraDraftSource> = {}) {
    super(model);

    this.sourceId = model.sourceId;
    this.kind = model.kind;
    this.title = model.title;
    this.excerpt = model.excerpt;
    this.type = model.type;
    this.locator = model.locator ? MessageClaraDraftSourceLocator.mapModel(model.locator) : null;
    this.snippet = model.snippet;
    this.retrievedAt = model.retrievedAt;
    this.partner = !!model.partner;
    this.items = MessageClaraDraftSourceItem.mapModels(model.items);
  }

  get sourceType(): MessageClaraDraftSourceType | undefined {
    return this.type ? MessageClaraDraftSourceType.getByKey(this.type) : undefined;
  }

  get isMessage(): boolean {
    return this.type === MessageClaraDraftSourceType.INBOX_MESSAGE.key;
  }

  get heading(): string {
    return this.locator?.label || this.title || '';
  }

  isItemLabelShown(item: MessageClaraDraftSourceItem): boolean {
    return !!item.label && item.label !== this.heading;
  }

  get externalUrl(): string | null {
    const url: string | null | undefined = this.locator?.url;

    return url?.startsWith('https://') ? url : null;
  }

  get snippetFields(): string[] {
    if (this.type !== MessageClaraDraftSourceType.FILE_SECTION.key || !this.snippet) {
      return [];
    }

    return this.snippet.split(MessageClaraDraftSourceSeparator.FIELD).filter(Boolean);
  }

  get estateDetailsTab(): string | null {
    const section: MessageClaraDraftSourceSection | undefined = this.locator?.section
      ? MessageClaraDraftSourceSection.getByKey(this.locator.section)
      : undefined;
    const tab: string | null | undefined = section ? section.tab : this.locator?.tab;

    if (this.partner || !tab || !MessageClaraDraftSourceTab.getByKey(tab)) {
      return null;
    }

    if (tab === EstateDetailsMainTabValue.INBOX && this.locator?.conversationId) {
      return `${tab}|${this.locator.conversationId}`;
    }

    return tab;
  }
}
